import { METERS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/meters_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'metersIndex',
	'allMetersIndex',
	'archivedMetersIndex',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
